// extracted by mini-css-extract-plugin
module.exports = {"sectionMenuList":"BaseLayout_sectionMenuList_10VPA","brandCover":"BaseLayout_brandCover_1Do4S"};